// extracted by mini-css-extract-plugin
export var backdropBlur = "_kx-0";
export var contentCard = "_kx-5";
export var frame = "_kx-2";
export var image = "_kx-4";
export var imagePane = "_kx-3";
export var modal = "_kx-1";